import { Controller, useWatch } from "react-hook-form";

import { FieldError, Label } from "@/components/field";
import {
  Select,
  SelectButton,
  SelectListBox,
  SelectListItem,
  SelectPopover,
} from "@/components/select";
import { useApplyDefaultComplexity } from "@/features/request/create/shared/useApplyDefaultComplexity";
import { COMPLEXITY_OPTIONS } from "@/features/shared/constants/complexityConstants";

import { useCreateVideoRequestFormContext } from "../useCreateVideoRequestForm";

export function ComplexitySelect() {
  const methods = useCreateVideoRequestFormContext();

  useApplyDefaultComplexity({
    applyDefault: (complexityId) =>
      methods.setValue("designComplexity", complexityId, {
        shouldValidate: true,
      }),
    designTypeId:
      useWatch({ control: methods.control, name: "videoType" }) ??
      methods.getValues("videoType"),
    hasComplexity: () => !!methods.getValues("designComplexity"),
  });

  return (
    <Controller
      control={methods.control}
      name="designComplexity"
      render={({
        field: { name, onBlur, onChange, value },
        fieldState: { error, invalid },
      }) => (
        <Select
          className="flex-1"
          isInvalid={invalid}
          name={name}
          onBlur={onBlur}
          onSelectionChange={onChange}
          placeholder="Select level"
          selectedKey={value}
        >
          <Label requiredHint>Level</Label>
          <SelectButton />
          <SelectPopover>
            <SelectListBox>
              {COMPLEXITY_OPTIONS.map(({ id, name }) => (
                <SelectListItem id={id} key={id}>
                  {name}
                </SelectListItem>
              ))}
            </SelectListBox>
          </SelectPopover>
          <FieldError>{error?.message}</FieldError>
        </Select>
      )}
    />
  );
}
